export { default as Residency } from './Residency';
